import Highcharts from 'highcharts';

export const figure16 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    type: "column",
    backgroundColor:'rgba(255, 255, 255, 0.0)',
    style: {
        fontFamily: 'Montserrat'
    }
},
colors: ['#92d050'],

credits: {
    enabled: false
},
title: {
    text: null
},
subtitle: {
    text: null
},

plotOptions: {
    series: {
      colorByPoint: true,
      borderWidth: 0
    }
},

exporting: {
    enabled: false
},


xAxis: [{
    categories: [
      "1995",
      "2000",
      "2005",
      "2010",
      "2012",
      "2014",
      "2016",
      "2017",
      "2018",
      "2019",
      "2020"],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {
        y: 32,
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
        }
    },
}],
yAxis: [{ // Primary yAxis
    labels: {
        format: '{value}',
        formatter: function () {
          return this.value.toString()[0];
      },
        style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
        },
    },
    offset: 10,
    gridLineWidth: 2,
    title: {
        text: 'Millones',
        style: {
            color: Highcharts.getOptions().colors[1]
        }
    }
}],
tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
        padding: 0
    }
},
legend: {
    enabled: false,
},

series: [{
    name: 'Lotes de recursos fitogenéticos almacenados <i>ex situ</i> (número)',
    dataLabels: {
        enabled: false,
        style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
        }

    },
    data: [3113370,
      3546414,
      4353291,
      4975260,
      5182083,
      5314851,
      5439953,
      5488741,
      5620484,
      5690198,
      5700826],
}],

}